import { type PropsWithChildren } from 'react';
import { ErrorBoundary } from '@mentimeter/errors/ErrorBoundary';
import type { CancelAddSlideTrigger } from '@mentimeter/editor-tracking';
import { PopoverContainer, PopoverHeader } from '@mentimeter/ragnar-ui/popover';
import { ErrorFallback } from './ErrorFallback';

const POPOVER_ID = 'add-slide-popover';
export const EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT = 105;

interface AddSlidePopoverProps {
  onDismiss: (trigger: CancelAddSlideTrigger) => void;
}

const getBannerHeight = () => {
  const headerHeight = document.querySelector('header')?.clientHeight || 0;
  const menuHeight =
    document.getElementById('header-layout')?.clientHeight || 0;
  const bannerHeight = headerHeight - menuHeight;
  return bannerHeight;
};

export const AddSlidePopover = ({
  onDismiss,
  children,
}: PropsWithChildren<AddSlidePopoverProps>) => {
  const bannerHeight = getBannerHeight();
  const height =
    (window.innerHeight - EDITOR_MOBILE_OVERVIEW_CONTAINER_HEIGHT) * 0.9;

  return (
    <PopoverContainer
      id={POPOVER_ID}
      maxHeight={`calc(80vh - ${bannerHeight}px)`}
      // defining height for mobile instead of max-height
      // because of breakpoint specificity issue
      height={[height, 'unset']}
      align="start"
      side="bottom"
      onInteractOutside={() => onDismiss('Clicked outside')}
      onEscapeKeyDown={() => onDismiss('Pressed escape')}
      withPortal={false}
      extend={({ theme }) => ({
        borderRadius: `${theme.kosmosBorderRadius['2xl']}px`,
        border: `1px solid ${theme.colors.border}`,
        boxShadow: undefined,
      })}
    >
      <ErrorBoundary
        feature="creation-experience"
        fallback={<ErrorFallback />}
        errorMessage="Error Occurred - Editor Slide Types"
      >
        <PopoverHeader onDismissClick={() => onDismiss('Clicked cancel')} />
        {children}
      </ErrorBoundary>
    </PopoverContainer>
  );
};
